import React from 'react';

import Upload from 'components/shared/LandingPage/blocks/AddNewContent/Upload';
import { IUploadProps } from 'components/shared/LandingPage/blocks/AddNewContent/Upload/types';

function FileUpload(props: IUploadProps) {
  return <Upload {...props} type="document" />;
}

export default FileUpload;
